import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";
import Loader from "../components/Loader";

const Home          = lazy(() => import("./pages/Home"));
const Programs      = lazy(() => import("./pages/Programs"));
const ProgramDetail   = lazy(() => import("./pages/ProgramDetail"));
const About         = lazy(() => import("./pages/About"));
const Notice        = lazy(() => import("./pages/Notice"));
const FAQs          = lazy(() => import("./pages/FAQs"));
const Articles      = lazy(() => import("./pages/Articles"));
const ArticleDetail = lazy(() => import("./pages/ArticleDetail"));
const Register      = lazy(() => import("./pages/Register"));
const Contact       = lazy(() => import("./pages/Contact"));
const Gallery       = lazy(() => import("./pages/Gallery"));
const PrivacyPolicy   = lazy(() => import("../Pages/PrivacyPolicy"));
const Terms           = lazy(() => import("../Pages/Terms"));
const InfoPage        = lazy(() => import("../Pages/Info/InfoPage"));
const Achievement     = lazy(() => import("../Pages/Achievement"));
const NotFound        = lazy(() => import("../Pages/NotFound"));

export default function Layout() {
  return (
    <div className="bg-bg text-fg min-h-screen">
      <Navbar />
      {/* pt-16 (64px) clears the fixed navbar. If the navbar restyle changes its
          height, this offset must move with it. */}
      <main className="pt-16">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route index                element={<Home />} />
            <Route path="programs"      element={<Programs />} />
            <Route path="programs/:slug"element={<ProgramDetail />} />
            <Route path="about"         element={<About />} />
            <Route path="notice"        element={<Notice />} />
            <Route path="faqs"          element={<FAQs />} />
            <Route path="articles"      element={<Articles />} />
            <Route path="articles/:url" element={<ArticleDetail />} />
            <Route path="register"      element={<Register />} />
            <Route path="contact"       element={<Contact />} />
            <Route path="gallery"       element={<Gallery />} />
            <Route path="privacy-policy"element={<PrivacyPolicy />} />
            <Route path="terms"         element={<Terms />} />
            <Route path="info/:exam"    element={<InfoPage />} />
            <Route path="achievements"  element={<Achievement />} />
            <Route path="*"             element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
